import { call, put } from "redux-saga/effects";
import { TransactionsResponse } from "reduxStore/dataTypes";
import {
  transactionsFailure,
  transactionsSuccess,
  transactionsRequest,
} from "../reducers/transactionsReducer";
import { fetchTransactions } from "services/apiService";

function* transactionsSaga(
  action: any
): Generator<any, void, TransactionsResponse | any> {
  try {
    const { payload } = action;
    yield put(transactionsRequest());
    let response = yield call(fetchTransactions, payload);
    yield put(transactionsSuccess(response.data));
  } catch (error: any) {
    if (error && error.response) {
      yield put(transactionsFailure(error.response));
    } else {
      yield put(transactionsFailure(error.message));
    }
  }
}

export default transactionsSaga;
